export const URL_V2 = '/api/v2/settings'
